export default __webpack_public_path__ + "static/media/action_view.980b8e9a.svg";